var map = {
	"./admin-dashboard.png": 23,
	"./general-scheme.png": 49,
	"./oval-capital-regulation.png": 50,
	"./oval-capital-small.png": 51,
	"./oval-capital.png": 31,
	"./page-404.png": 52,
	"./payment-bca.png": 80,
	"./payment-bni.png": 81,
	"./payment-bri.png": 82,
	"./payment-fasapay.png": 83,
	"./payment-local.png": 84,
	"./payment-mandiri.png": 85,
	"./payment-mastercard.png": 86,
	"./payment-visa.png": 87,
	"./payment-visamastercard.png": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;